import { type RowDataType } from '../types/rowDataType';
import { getRankDataById } from './useRankData';
import dialogController from '@kk/vue-dialog';
import Toast from '@kk/toast';
import { type RankInfoType } from '../types/rankListType';

export async function useThrowCoinDialog(config: RowDataType) {
    try {
        const res = await getRankDataById(
            config.moduleConfig.baseModule.topicRankId,
            config.moduleConfig.baseModule.rankDisplayType,
            config.id,
            0,
            1
        );

        if (res.code !== 200) {
            throw res;
        }

        if (res.data.peltCoinErrorToast) {
            Toast.show(res.data.peltCoinErrorToast);
        } else if (res.data.peltCoinNotifyText) {
            await openThrowCoinNoticeDialog(config, res.data);
        }
    } catch (error) {
        console.error(error);
    }
}

function openThrowCoinNoticeDialog(config: RowDataType, rankInfo: RankInfoType) {
    return new Promise((resolve) => {
        dialogController.asyncShow({
            component: () =>
                import(/* webpackChunkName: "outside-assist" */ '../ThrowCoinNoticeDialog.vue'),
            props: {
                withCloseBtn: false,
                modal: true,
            },
            contentProps: {
                config,
                rankInfo,
            },
            events: {
                afterLeave: resolve,
            },
        });
    });
}
